import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/export-duck";
import { TransportWithPicking } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "EXPORT_TRANSPORTS_" }
);

export interface ExportTransportsState extends IState {
  data: TransportWithPicking[];
}

interface ISuccessExportTransportsAction extends ISuccessAction {
  data: TransportWithPicking[];
}

const INITIAL_STATE: ExportTransportsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ExportTransportsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ExportTransportsState,
  action: ISuccessExportTransportsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ExportTransportsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const exportTransports = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ExportTransportsTypes = Types;
export const ExportTransportsActions = Creators;